import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1503.117 -4099)">
      <path
        d="M155.633,15.75a15,15,0,1,1-15-15,15,15,0,0,1,15,15"
        transform="translate(-1628 4099)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M127.652,23.244l12.98-7.494V.75a15,15,0,1,1-13.4,21.717c.133.263.271.523.418.777"
        transform="translate(-1628 4099)"
        fill={color}
      />
    </g>
  </svg>
);
